import styled from 'styled-components';

const P = styled.p`
  margin-top: 0;
  margin-bottom: ${props => props.theme.paddingS};
  font-size: ${props => props.theme.fontSizeBase};
  font-weight: ${props => props.theme.fontWeightRegular};
  line-height: ${props => props.theme.lineHeightBase};
  color: ${props => props.theme.primaryText};
`

export default P;
